module.exports = __webpack_public_path__ + "img/case2.c48a6a79.png";